var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { NotificationsUrls } from "../../constants/notifications/notifications.constants";
import { NotificationClientService } from "../basics/notification-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { SignalClientService, SignalFunctions } from "../basics/signal-client.service";
import { toNative } from "../../utilities/promise-utils";
var NotificationsService = /** @class */ (function () {
    function NotificationsService(requestClient, notificationClientService, signalService) {
        var _this = this;
        this.requestClient = requestClient;
        this.notificationClientService = notificationClientService;
        this.signalService = signalService;
        this.subscribers = [];
        this.interceptShowingNotification = function (notificationModel) {
            if (notificationModel.persistInServer) {
                _this.addNewNotification(notificationModel.title, notificationModel.description, notificationModel.notificationType);
            }
        };
        this.pushedNotification = function (notification) {
            _this.subscribers.forEach(function (subscriber) {
                subscriber['pushedNotification'].call(subscriber, notification);
            });
        };
        this.deletedNotification = function (notification) {
            _this.subscribers.forEach(function (subscriber) {
                subscriber['deletedNotification'].call(subscriber, notification);
            });
        };
        this.notificationClientService.subscribeShow(this.interceptShowingNotification);
        this.signalService.subscribe(SignalFunctions.pushedNotification, this.pushedNotification);
        this.signalService.subscribe(SignalFunctions.deletedNotification, this.deletedNotification);
    }
    NotificationsService.prototype.fetchNotificationsNotDismissed = function () {
        return toNative(this.requestClient.get(NotificationsUrls.GetNotificationsForLoggedUser, null, null));
    };
    NotificationsService.prototype.addNewNotification = function (title, message, typeId) {
        return toNative(this.requestClient.post(NotificationsUrls.AddNotification, null, { title: title, message: message, typeId: typeId }));
    };
    NotificationsService.prototype.dismissNotification = function (notificationId) {
        return toNative(this.requestClient.post(NotificationsUrls.DismissNotification, null, { notificationId: notificationId }));
    };
    NotificationsService.prototype.markNotificationsAsSeen = function (notificationsIds) {
        return this.requestClient.post(NotificationsUrls.MarkNotificationsAsSeen, null, { notificationsIds: notificationsIds });
    };
    NotificationsService.prototype.register = function (vm) {
        var _this = this;
        this.subscribers.push(vm);
        var detached = vm.detached;
        vm.detached = function () {
            if (detached) {
                detached.call(vm);
            }
            var index = _this.subscribers.indexOf(vm);
            if (index >= 0) {
                _this.subscribers.splice(index, 1);
            }
            vm = null;
        };
    };
    NotificationsService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient, NotificationClientService, SignalClientService])
    ], NotificationsService);
    return NotificationsService;
}());
export { NotificationsService };
